import { Facebook, Instagram, Linkedin } from 'lucide-react'
import { Link } from 'react-router-dom'
import stylereLogo from '@/assets/stylere-logo.png'

const footerColumns = [
  {
    title: 'Resources',
    links: [
      { label: 'Platform Services', to: '/platform-services' },
      { label: 'Delivery Information', to: '/delivery-info' },
      { label: 'Help Center', to: '/help-center' },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'About Us', to: '/about-us' },
      { label: 'How It Works', to: '/how-it-works' },
      { label: 'Team', to: '/team' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Style.re API', to: '/platform-services' },
      { label: 'Robot Leasing', to: '/robot-leasing' },
      { label: 'For Retailers', to: '/retailer-onboarding' },
    ],
  },
]

const socialLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/_style.re/',
    icon: Instagram,
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61554334604723',
    icon: Facebook,
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/stylere/',
    icon: Linkedin,
  },
]

export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer__inner">
        <div className="public-footer__brand">
          <Link to="/" aria-label="Style.re home">
            <img src={stylereLogo} alt="Style.re" />
          </Link>
          <p>The fastest way to get fashion from your favorite stores to your door.</p>
        </div>

        {footerColumns.map((column) => (
          <nav
            key={column.title}
            className="public-footer__column"
            aria-label={`${column.title} links`}
          >
            <h2>{column.title}</h2>
            {column.links.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
          </nav>
        ))}

        <div className="public-footer__social">
          <h2>Follow us</h2>
          <div>
            {socialLinks.map(({ label, href, icon: Icon }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
              >
                <Icon aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="public-footer__legal">
        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/accessibility">Accessibility</Link>
        <span>© {new Date().getFullYear()} Style.re. All rights reserved.</span>
      </div>
    </footer>
  )
}
